export default [
    {
        path: '/accounting/datev-export/list',
        name: 'accounting_datev_export_list',
        component: () => import('@src/accounting/datev/datev-export-list'),
        props(route) {
            return { ...route.params };
        },
        meta: {
            title: 'DATEV Exporte',
            role: 'ROLE_DATEV_EXPORT_LIST',
            favoriteRouteName: 'accounting_datev_export_list',
        },
    },
    {
        path: '/accounting/datev-export/create',
        name: 'accounting_datev_export_create',
        component: () => import('@src/accounting/datev/datev-export-create'),
        meta: {
            title: 'DATEV Export erstellen',
            role: 'ROLE_DATEV_EXPORT_CREATE',
        },
    },
    {
        path: '/accounting/datev-export/download/:id?',
        name: 'accounting_datev_export_download',
        component: () => import('@src/accounting/datev/datev-export-download'),
        props(route) {
            const props = { ...route.params };
            props.id = Number(props.id);

            return props;
        },
        meta: {
            title: 'DATEV Export Download',
            role: 'ROLE_DATEV_EXPORT_LIST',
        },
    },
    {
        path: '/accounting/datev-export-not-exported-documents/list',
        name: 'accounting_datev_export_not_exported_documents_list',
        component: () => import('@src/accounting/datev/datev-export-not-exported-documents-list'),
        props(route) {
            return { ...route.params };
        },
        meta: {
            title: 'DATEV nicht exportierte Belege',
            role: 'ROLE_DATEV_EXPORT_LIST',
        },
    },
];
